/**
 * Document Form Page — Type Dispatcher
 * Detecta o tipo da database e renderiza o formulario correto
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import { useDatabase } from '../hooks/useDatabases';
import { ProductFormPage } from './ProductFormPage';
import { PropertyFormPage } from './PropertyFormPage';
import { ArticleFormPage } from './ArticleFormPage';

export const DocumentFormPage: React.FC = () => {
  const { id: databaseId, documentId } = useParams<{ id: string; documentId: string }>();
  const { data: database, isLoading } = useDatabase(databaseId);

  if (isLoading) {
    return (
      <div className="min-h-full flex items-center justify-center" style={{ backgroundColor: 'var(--theme-page-background)' }}>
        <p className="text-sm" style={{ color: 'var(--theme-muted-text)' }}>Carregando...</p>
      </div>
    );
  }

  switch (database?.type) {
    case 'products':
      return <ProductFormPage documentId={documentId} />;
    case 'properties':
      return <PropertyFormPage documentId={documentId} />;
    case 'documents':
      return <ArticleFormPage documentId={documentId} />;
    default:
      return <ProductFormPage documentId={documentId} />;
  }
};
